var $ = jQuery;

var MigrationProgressStageView = Backbone.View.extend( {
	tagName: 'div',
	className: 'migration-progress-stage-container hide-tables',
	$totalProgressElem: null,
	$tabElem: null,
	$showHideTablesElem: null,
	$pauseBeforeFinalizeElem: null,
	$pauseBeforeFinalizeCheckbox: null,
	$itemsContainer: null,
	itemViews: null,
	maxDomNodes: 140,
	visibleDomNodes: 0,
	itemCount: 0,
	percentDone: 0,
	sizeDone: 0,
	tablesDone: 0,
	queuedElements: null,
	$truncationNotice: null,
	$truncationNoticeHiddenItems: null,
	shouldHideItemProgress: false,
	initialize: function() {
		this.$el.empty();
		this.$el.attr( 'data-stage', this.model.get( 'name' ) ).addClass( 'queued ' + this.model.get( 'name' ) );

		this.queuedElements = [];

		this.initTotalProgressElem();
		wpmdb.current_migration.view.$el.parent().find( '.stage-tabs' ).after( this.$totalProgressElem );

		this.$itemsContainer = $( '<div class=progress-items />' );
		this.$el.append( this.$itemsContainer );

		this.initTabElem();

		this.model.on( 'item:added', this.maybeAddElementToView, this );

		_.each( this.model.get( 'itemModels' ), this.maybeAddElementToView, this );
		this.model.on( 'change', function() {
			this.updateProgressElem();
			this.updateStageTotals();
		}, this );

		this.model.on( 'change:status', function( e ) {
			this.$el.removeClass( 'queued active' ).addClass( this.model.get( 'status' ) );
			this.$totalProgressElem.removeClass( 'queued active' ).addClass( this.model.get( 'status' ) );
			this.$tabElem.removeClass( 'queued active' ).addClass( this.model.get( 'status' ) )
				.find( '.stage-status' ).text( this.model.get( 'strings' )[ this.model.get( 'status' ) ] );
		}, this );

		this.model.on( 'change:items', function( item ) {
			if ( item.name ) {
				this.setItemProgress( item );
			}
		}, this );

		this.model.on( 'activateTab', function() {
			if ( 'complete' === wpmdb.current_migration.model.get( 'migrationStatus' ) ) {
				this.$totalProgressElem.addClass( 'active' ).siblings().removeClass( 'active' );
				this.$tabElem.addClass( 'active' ).siblings().removeClass( 'active' );
				this.$el.addClass( 'active' ).siblings().removeClass( 'active' );
			}
		}, this );
	},
	initTotalProgressElem: function() {
		this.initShowHideTablesElem();
		this.initPauseBeforeFinalizeElem();

		this.$totalProgressElem = $( '<div class="stage-progress ' + this.model.get( 'name' ) + '" />' )
			.append( '<span class=percent-complete>0</span>% ' + this.model.get( 'strings' ).complete + ' ' )
			.append( '<span class="size-complete-wrap">(<span class=size-complete>0 MB</span> / <span class=size-total>0 MB</span>) </span>' )
			.append( '<span class="items-complete-wrap"><span class=items-complete>0</span> <span class=lowercase >of</span> <span class=items-total>0</span> ' + this.model.get( 'strings' ).items_migrated + '</span>' )
			.append( this.$showHideTablesElem )
			.append( '<div class=progress-bar-wrapper><div class=progress-bar /></div>' );

		this.updateStageTotals();
	},
	initShowHideTablesElem: function() {
		this.$showHideTablesElem = $( '<a class="show-hide-tables">' ).text( this.model.get( 'strings' ).show_items );
		var self = this;
		this.$showHideTablesElem.on( 'click show-hide-progress-tables', function() {
			var progTablesHidden;
			if ( self.$el.hasClass( 'hide-tables' ) ) { // show tables
				progTablesHidden = false;
				self.$el.add( self.$el.siblings() ).removeClass( 'hide-tables' );
				self.$showHideTablesElem.text( self.model.get( 'strings' ).hide_items );
			} else { // hide tables
				progTablesHidden = true;
				self.$el.add( self.$el.siblings() ).addClass( 'hide-tables' );
				self.$showHideTablesElem.text( self.model.get( 'strings' ).show_items );
			}

			if ( Boolean( progTablesHidden ) !== Boolean( wpmdb_data.prog_tables_hidden ) ) {
				wpmdb_data.prog_tables_visibility_changed = true;
				wpmdb_data.prog_tables_hidden = progTablesHidden;
			}
		} );

		// show progress tables on init if hidden is false
		if ( !wpmdb_data.prog_tables_hidden ) {
			this.$showHideTablesElem.triggerHandler( 'show-hide-progress-tables' );
		}

		// make sure text reflects current state when showing
		this.model.on( 'change:status activateTab', function() {
			if ( wpmdb_data.prog_tables_hidden ) {
				self.$showHideTablesElem.text( self.model.get( 'strings' ).show_items );
			} else {
				self.$showHideTablesElem.text( self.model.get( 'strings' ).hide_items );
			}
		} );
	},
	initPauseBeforeFinalizeElem: function() {
		this.$pauseBeforeFinalizeElem = $( '.pause-before-finalize' );
		this.$pauseBeforeFinalizeCheckbox = this.$pauseBeforeFinalizeElem.find( 'input[type=checkbox]' );
		var self = this;
		var isChecked = false;
		var migrationIntent = wpmdb.current_migration.model.get( 'migrationIntent' );

		// make sure checkbox is checked based on current state
		if ( wpmdb_data.pause_before_finalize ) {
			isChecked = true;
		}
		this.$pauseBeforeFinalizeCheckbox.prop( 'checked', isChecked );

		// only display on certain migrations
		if ( -1 !== $.inArray( migrationIntent, [ 'push', 'pull', 'find_replace', 'import' ] ) ) {
			if ( 'find_replace' === migrationIntent ) {
				$( '#pause-before-finalize-label' ).text( wpmdb_strings.pause_before_finalize_find_replace );
			}
			this.$pauseBeforeFinalizeElem.show();
		} else {
			this.$pauseBeforeFinalizeElem.hide();
		}

		// hide on media stage
		wpmdb.current_migration.model.on( 'change:activeStage', function() {
			if ( -1 !== $.inArray( wpmdb.current_migration.model.get( 'activeStageName' ), [
				'media',
				'themes',
				'plugins'
			] ) ) {
				self.$pauseBeforeFinalizeElem.hide();
			}
		} );

		this.$pauseBeforeFinalizeElem.on( 'click', function() {
			var pauseBeforeFinalizeValue = Boolean( self.$pauseBeforeFinalizeCheckbox.is( ':checked' ) );
			if ( pauseBeforeFinalizeValue !== Boolean( wpmdb_data.pause_before_finalize ) ) {
				wpmdb_data.pause_before_finalize_changed = true;
				wpmdb_data.pause_before_finalize = pauseBeforeFinalizeValue;
			}
		} );
	},
	initTabElem: function() {
		var self = this;
		this.$tabElem = $( '<a class=stage-tab>' )
			.append( '<span class=stage-title>' + this.model.get( 'strings' ).stage_title + '</span> ' )
			.append( '<span class=stage-status>' + this.model.get( 'strings' ).queued + '</span> ' )
			.on( 'click', function() {
				self.model.activateTab();
			} );
	},
	updateProgressElem: function() {
		var percentDone = Math.max( 0, this.model.getTotalProgressPercent() );
		var sizeDone = wpmdb.functions.convertKBSizeToHRFixed( Math.min( this.model.getTotalSizeTransferred(), this.model.get( 'totalSize' ) ) );
		var tablesDone = Math.min( this.model.countItemsComplete(), this.model.get( 'items' ).length );

		if ( 'complete' === this.model.get( 'status' ) && 0 === this.model.get( 'totalSize' ) ) {
			percentDone = 100;
			this.$showHideTablesElem.fadeOut();
		}

		if ( percentDone !== this.percentDone ) {
			this.percentDone = percentDone;
			this.$totalProgressElem.find( '.percent-complete' ).text( percentDone );
			this.$totalProgressElem.find( '.progress-bar-wrapper .progress-bar' ).css( { width: percentDone + '%' } );
		}
		if ( sizeDone != this.sizeDone ) {
			this.sizeDone = sizeDone;
			this.$totalProgressElem.find( '.size-complete' ).text( sizeDone );
		}
		if ( tablesDone != this.tablesDone ) {
			this.tablesDone = tablesDone;
			this.$totalProgressElem.find( '.items-complete' ).text( wpmdb.functions.wpmdb_add_commas( tablesDone ) );
		}
	},
	updateStageTotals: function( itemCount ) {
		itemCount = itemCount || this.model.get( 'items' ).length;
		if ( itemCount === this.itemCount ) {
			return;
		}
		this.itemCount = itemCount;
		this.$totalProgressElem.find( '.items-total' ).text( wpmdb.functions.wpmdb_add_commas( itemCount ) );
		this.$totalProgressElem.find( '.size-total' ).text( wpmdb.functions.convertKBSizeToHRFixed( this.model.get( 'totalSize' ) ) );

		if ( !this.shouldHideItemProgress && 500 < itemCount ) {
			let stageName = this.model.get( 'name' ).toLowerCase();
			if ( 'themes' == stageName || 'plugins' === stageName ) {
				this.hideItemProgress();
			}
		}
	},
	hideItemProgress: function() {
		if ( this.shouldHideItemProgress ) {
			return;
		}
		this.shouldHideItemProgress = true;
		this.$itemsContainer.empty();
		if ( this.$showHideTablesElem ) {
			this.$showHideTablesElem.hide();
		}
	},
	maybeAddElementToView: function( item ) {
		var maxDomNodes = this.shouldHideItemProgress ? 0 : this.maxDomNodes;
		if ( this.visibleDomNodes < maxDomNodes ) {
			++this.visibleDomNodes;
			this.$itemsContainer.append( item.$el );
		} else {
			this.queuedElements.push( item );
			if ( !this.$truncationNotice ) {
				this.showTruncationNotice();
			} else {
				this.updateTruncationNotice();
			}
		}
	},
	showTruncationNotice: function() {
		if ( this.$truncationNotice ) {
			return;
		}
		var hiddenItemsCount = this.shouldHideItemProgress ? this.model.get( 'items' ).length : this.queuedElements.length;
		this.$truncationNotice = $( '<div class="truncation-notice" >' + wpmdb_strings.progress_items_truncated_msg.replace( '%1$s', '<span class="hidden-items">' + wpmdb.functions.wpmdb_add_commas( hiddenItemsCount ) + '</span>' ) + '</div>' );
		this.$truncationNoticeHiddenItems = this.$truncationNotice.find( '.hidden-items' );
		this.$itemsContainer.after( this.$truncationNotice );
	},
	updateTruncationNotice: function() {
		var hiddenItemsCount = this.shouldHideItemProgress ? this.model.get( 'items' ).length : this.queuedElements.length;
		this.$truncationNoticeHiddenItems.text( wpmdb.functions.wpmdb_add_commas( hiddenItemsCount ) );
	},
	getNextElementForView: function( $el ) {
		var queueItem;

		if ( this.shouldHideItemProgress ) {
			return false;
		}

		if ( this.queuedElements.length ) {
			if ( $el ) {
				this.queuedElements.push( $el );
			}
			queueItem = this.queuedElements.shift();
			if ( queueItem instanceof $ ) {
				$el = queueItem;
			} else {
				$el = queueItem.$el;
			}
		}
		return $el;
	},
	setItemProgress: function( item ) {
		var percentDone = Math.min( 100, Math.ceil( 100 * (item.transferred / item.size) ) );

		if ( item.hasOwnProperty( 'exactPercent' ) ) {
			percentDone = 100 * item.exactPercent;
		}

		if ( 0 === item.size ) {
			percentDone = 100;
		}

		item.updateProgress( percentDone )
		if ( 100 <= percentDone || 0 === item.size ) {
			this.elemComplete( item );
		}
	},
	elemComplete: function( item ) {
		if ( this.shouldHideItemProgress ) {
			return;
		}

		var $el = item.$el.addClass( 'complete' );

		// skip moving item to end of list if there's only one item in the list
		var numItems = this.model.get( 'items' ).length;
		if ( 1 === numItems ) {
			return;
		}

		var $nextEl = this.getNextElementForView( $el );

		var height = $el.height();
		var marginBottom = $el.css( 'margin-bottom' );

		var $clone = false;
		if ( $nextEl === $el ) {
			$clone = $nextEl.clone().css( {
				height: 0,
				marginBottom: 0,
				display: 'block'
			} ).addClass( 'clone complete' );
			$clone.appendTo( this.$itemsContainer );
		}
		$el.css( { height: height, marginBottom: marginBottom } );

		setTimeout( function() {
			$el.css( { height: 0, marginBottom: 0 } );

			var timeout = 0;
			if ( $clone ) {
				timeout = 250;
				$clone.css( { height: height, marginBottom: marginBottom } );
				$clone.find('.progress-bar').addClass('progress-bar-no-transition').css({width: '100%'});
			}

			setTimeout( function() {
				$el.css( {  display: 'none' } );
				$el.remove();
				$clone && $clone.remove();

				this.$itemsContainer.find( '.item-progress:not(.clone)' ).last().after( $nextEl.css( {
					height: 'auto',
					marginBottom: marginBottom,
					display: 'block'
				} ) );
			}.bind( this ), timeout );

		}.bind( this ), 1000 );

	}
} );

module.exports = MigrationProgressStageView;



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/modules/MigrationProgressStage-view.js